// @ts-ignore
import { ref, defineComponent, Transition } from 'vue'
import { useRoute } from 'vue-router'
// @ts-ignore
import mainImage from './assets/main.png'
import ModalWindow from './components/modal-window/index'
import VeryBad from './components/smiles/very-bad-smiley'
import Bad from './components/smiles/bad-smiley'
import Neutral from './components/smiles/neutral-smiley'
import Good from './components/smiles/good-smiley'
import VeryGood from './components/smiles/very-good-smiley'
import Checkbox from './components/checkbox-button'
import { Invoice } from './types'
import axios from '@/axios'
import './index.sass'
import './components/smiles/smiles.sass'
import { object, string, setLocale } from "yup"
import { useField, useForm } from 'vee-validate'
import { host } from '@/const'
export default defineComponent({
    name: 'rating',
    setup() {
        const route = useRoute()
        const complaintsList: string[] = [
            'Цена',
            'Товар (соответствие запросу, качество)',
            'Сроки (оформления, комплектации, доставки)',
            'Менеджер (оперативность, компетентность, вовлеченность, доброжелательность)',
            'Логист (оперативность, компетентность, вовлеченность, доброжелательность)',
        ];
        const estimation = ref(0)
        const complaint = ref('')
        const takeSurvey = ref(false)
        const changeComplain = ref(false)
        const showEnd = ref(false)
        const recommend = ref<boolean | null>(null)
        const showCall = ref(false)
        const answers = ref([])
        const hash = route.params.hash
        const errorMassege = ref('')
        let formData = new FormData()
        type FormInputs = {
            phone: string | undefined;
        };
        // @ts-ignore
        formData.append('hash', hash)

        // @ts-ignore
        const invoice: Invoice = (axios.post(`${host}/api/v1/rating/get-invoice`, formData))
            .then(json => {
                errorMassege.value = json.data.errors;
            })
            .catch(e => {
            })
            .finally(() => {
            })

        const schema = object().shape(
            {
                phone: string().required().length(18)
                // @ts-ignore
            }, [['phone']])

        const { handleSubmit } = useForm<FormInputs>({ validationSchema: schema })
        const { value: phone, errorMessage: phoneError } = useField<string | undefined>('phone')
        const initialValues = {
            phone: ''
        }

        const onSubmit = handleSubmit(async (values) => {

            const result = (axios.post(`${host}/api/v1/rating/create-task`, { 'phone': values.phone, 'hash': hash }))
                .then(json => {
                    showCall.value = false
                })
                .catch(e => {
                })
                .finally(() => {
                })

        })
        // @ts-ignore
        answers.value['checkboxAnswer'] = []

        const setMark = (mark: number) => {
            // @ts-ignore
            answers.value['rating'] = mark
            if (mark !== estimation.value) {
                estimation.value = mark
                changeComplain.value = true
                setTimeout(() => {
                    changeComplain.value = false
                }, 100)
            }
        }
        const sendRate = () => {
            window.scrollTo(0, 0)
            setTimeout(() => {
                showEnd.value = true
            }, 300)
        }
        const setCheckbox = (element: any) => {
            let idElem = element.target.value
            // @ts-ignore
            if (element.target.checked) {
                // @ts-ignore
                if (!answers.value['checkboxAnswer'][idElem]) {
                    // @ts-ignore
                    answers.value['checkboxAnswer'].push(idElem)
                }
            }
            // @ts-ignore
            if (!element.target.checked && answers.value['checkboxAnswer'].includes(idElem)) {
                // @ts-ignore
                answers.value['checkboxAnswer'] = answers.value['checkboxAnswer'].filter(function (geeks) {
                    // @ts-ignore
                    return geeks != idElem
                });
            }
        }
        const sendAnswer = () => {
            try {
                let formData = new FormData()

                // @ts-ignore
                formData.append('rating', answers.value.rating)
                // @ts-ignore
                if (answers.value.checkboxAnswer.length) {
                    // @ts-ignore
                    for (var i = 0; i < answers.value.checkboxAnswer.length; i++) {
                        // @ts-ignore
                        formData.append('checkboxes[]', answers.value.checkboxAnswer[i]);
                      }
                    // formData.append('checkboxes', answers.value.checkboxAnswer)
                }
                // @ts-ignore
                if (answers.value.textAnswer) {
                    // @ts-ignore
                    formData.append('comment', answers.value.textAnswer)
                }
                // @ts-ignore
                formData.append('hash', hash)

                let response = axios.post(`${host}/api/v1/rating/save-answer`, formData)

            } catch (error: any) {
            }
        }
        return () => {
            return (
                <div>
                    {!errorMassege.value ?
                        <div class="rating-us-page">
                            {!takeSurvey.value && !showEnd.value &&
                                <div class="rating-us-content">
                                    <div class="rating-us-text">
                                        <h2>Помогите нам стать лучше!</h2>
                                        <p>
                                            Для повышения качества нашей работы, пожалуйста, пройдите небольшой опрос.<br/>
                                            Ваш ответ очень важен для нас. 
                                        </p>
                                        <div class="rating-us-buttons">
                                            <div class="rating-us-button rating-us-button-rate"
                                                onClick={() => {
                                                    takeSurvey.value = true
                                                }}
                                            >
                                                Пройти опрос 
                                            </div>
                                            <div class="rating-us-button rating-us-button-call"
                                                onClick={() => {
                                                    showCall.value = true
                                                }}
                                            >
                                                Лучше позвоните
                                            </div>
                                        </div>
                                    </div>
                                    <div class="rating-us-image">
                                        <div class="rating-us-image-container">
                                            <img src={mainImage} alt="Оцените нас!" />
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                takeSurvey.value && !showEnd.value &&
                                <div class="rating-us-survey-block">
                                    <h2 class="rating-us-survey-block-header">
                                        Оцените качество нашей работы
                                    </h2>
                                    <div class="rating-us-survey-text">Пожалуйста, оцените по шкале от 1 до 10, насколько <br />
                                            вероятно, что Вы порекомендуете нас другу или коллеге?</div>  
                                    <div class="rating-us-survey-rating-block">
                                        <div class="rating-us-survey-question">
                                            <div class="rating-us-survey-question-rate">
                                                {
                                                    [...Array.from({ length: 10 }, (_, i) => i + 1)].map((mark: number) => (
                                                        <div id={
                                                            `${mark <= 6 ? 'negative' : mark > 6 && mark < 9 ? 'neutral' : 'positive'}`
                                                        }
                                                            class={{
                                                                "rating-us-survey-mark set-negative-mark set-rate": estimation.value <= 5 && estimation.value === mark,
                                                                "rating-us-survey-mark set-neutral-mark set-rate": estimation.value > 5 && mark < 9 && estimation.value === mark,
                                                                "rating-us-survey-mark set-positive-mark set-rate": estimation.value > 8 && estimation.value === mark,
                                                                "rating-us-survey-mark": estimation.value !== mark
                                                            }}
                                                            onClick={() => {
                                                                setMark(mark)
                                                            }}
                                                        >
                                                            <span>
                                                                {mark}
                                                            </span>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div class="rating-us-survey-question-rate-helpers">
                                                <span>Маловероятно</span>
                                                <span>С большой вероятностью</span>
                                            </div>
                                        </div>
                                        <div class="rating-us-survey-rate-smiley">
                                            <Transition name="show-number">
                                                {
                                                    estimation.value > 0 && estimation.value < 3 ?
                                                        <VeryBad />
                                                        : estimation.value > 2 && estimation.value < 5 ?
                                                            <Bad />
                                                            : estimation.value > 4 && estimation.value < 7 ?
                                                                <Neutral />
                                                                : estimation.value > 6 && estimation.value < 9 ?
                                                                    <Good />
                                                                    : estimation.value > 8 && estimation.value < 11 ?
                                                                        <VeryGood />
                                                                        : null
                                                }
                                            </Transition>

                                        </div>
                                    </div>
                                    <Transition name="slide-from-above">
                                        {estimation.value !== 0 && !changeComplain.value &&
                                            <div class="rating-us-survey-complaints-block">
                                                <div class="rating-us-survey-complaint">
                                                    {
                                                        estimation.value > 0 && estimation.value < 7 &&
                                                        <h3>Что вас разочаровало?</h3>
                                                    }
                                                    {
                                                        estimation.value > 6 && estimation.value < 9 &&
                                                        <h3>Что следует улучшить?</h3>
                                                    }
                                                    {
                                                        estimation.value > 8 &&
                                                        <h3>Что особенно понравилось?</h3>
                                                    }
                                                    <div class="rating-us-survey-complaint-checklist">
                                                        
                                                            {complaintsList.map((complaint: string, index) => (
                                                                // @ts-ignore
                                                                <Checkbox onClick={(e: any) => {
                                                                    setCheckbox(e)
                                                                }} class="rating-us-survey-complaint-checklist-box" label={complaint} id={index}>
                                                                    {
                                                                        () => (
                                                                            <span>{complaint}</span>
                                                                        )
                                                                    }
                                                                </Checkbox>
                                                            ))}
                                                             
                                                            <textarea
                                                                placeholder="Что мы можем улучшить для того, чтобы Вы поставили нам более высокую оценку?"
                                                                // @ts-ignore
                                                                onInput={(event: InputEvent) => {
                                                                    // @ts-ignore
                                                                    answers.value['textAnswer'] = (event.target as HTMLInputElement).value
                                                                    complaint.value = (event.target as HTMLInputElement).value
                                                                }}
                                                            >
                                                            </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </Transition>
                                    <div class={{
                                        "rating-us-button rating-us-button-rate-submit": estimation.value !== 0,
                                        "rating-us-button rating-us-button-rate-submit rate-button-disabled": estimation.value === 0
                                    }}

                                        onClick={() => {
                                            // @ts-ignore
                                            setTimeout(() => {
                                                recommend.value = true
                                                showEnd.value = true
                                                sendAnswer()
                                            }, 500)
                                        }}
                                    >Отправить результат</div>
                                </div>
                            }
                            {
                                recommend.value !== null &&
                                <div class="rating-us-thanks">
                                    <h3>Спасибо! <br /> Вы помогаете нам стать лучше!</h3>
                                    <div class="rating-us-heart">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 40.0026C0 17.909 17.9116 0 39.9997 0C62.0925 0 79.9995 17.909 79.9995 40.0026C79.9995 62.0919 62.0925 80 39.9997 80C17.9116 80 0 62.0919 0 40.0026Z" fill="#F94343" />
                                            <path d="M60.929 5.86005C64.9083 12.0786 67.2218 19.4727 67.2218 27.4069C67.2218 49.4963 49.3101 67.4043 27.222 67.4043C19.5496 67.4043 12.384 65.2456 6.29297 61.5007C13.4023 72.5992 25.8423 79.9531 39.9999 79.9531C62.0927 79.9531 79.9997 62.0451 79.9997 39.951C79.9997 25.5345 72.3695 12.8989 60.929 5.86005Z" fill="#E53939" />
                                            <path d="M5.4397 44.2218C5.4397 23.7092 22.0656 7.08279 42.577 7.08279C54.5619 7.08279 65.2235 12.7654 72.0137 21.5833C65.5989 10.449 53.5811 2.954 39.813 2.954C19.3016 2.954 2.67578 19.5813 2.67578 40.092C2.67578 48.6143 5.54764 56.4655 10.3763 62.7305C7.23697 57.282 5.4397 50.9607 5.4397 44.2218Z" fill="#F76363" />
                                            <path d="M63.5372 35.3428V35.2349C63.5372 28.2002 58.4503 21.7569 50.8014 21.7569C44.7245 21.7569 41.2003 26.126 39.999 30.2135C38.7977 26.126 35.2736 21.7569 29.1967 21.7569C21.5477 21.7569 16.4609 28.2002 16.4609 35.2349L16.4656 35.3428C16.4234 36.8727 16.4609 52.4483 39.9943 65.1379V65.1426V65.1379L39.999 65.1426L40.0037 65.1379L40.0084 65.1426V65.1379C63.5371 52.4483 63.5747 36.8727 63.5372 35.3428Z" fill="white" />
                                        </svg>
                                    </div>
                                </div>
                            }
                            <Transition name="modal">
                                {showCall.value &&
                                    <ModalWindow
                                        onClose={(value: boolean) => {
                                            showCall.value = value
                                        }}
                                    >
                                        {() => (
                                            <div class="modal-better-call-me">
                                                {
                                                    <div class="better-call-me-form">
                                                        <form
                                                            onSubmit={values => onSubmit(values)}
                                                        >
                                                            <label for="phone">
                                                                Введите номер телефона
                                                            </label>
                                                            <input
                                                                name="phone"
                                                                type="tel"
                                                                key="phone"
                                                                v-maska={'+7 (###) ###-##-##'}
                                                                placeholder="+7(___) ___-__-__"
                                                                v-model={phone.value}
                                                            />
                                                            <button class="rating-us-button rating-us-button-call-me"
                                                            >Отправить</button>
                                                        </form>
                                                    </div>
                                                }
                                            </div>
                                        )}
                                    </ModalWindow>

                                }
                            </Transition>
                        </div>
                        : <div class="error-block">
                            <h2>{errorMassege.value}</h2>
                        </div>}
                </div>
            )
        }
    }
})